import { defineStore } from 'pinia'

export default defineStore('select', {
  state: () => ({
    tokenId: null,
  }),
})